<template lang="html">
  <div class="card-fade">
    <div class="content">
      <h5 class="title">{{ title }}</h5>
      <p class="description">{{ description }}</p>
      <a :href="link">
        <Button>{{ buttonText }}</Button>
      </a>
    </div>
    <div
      class="image"
      :style="{ 'background-image': 'url(' + imageURL + ')' }"
    ></div>
  </div>
</template>
<script>
import Button from "./General/Button.vue";

export default {
  components: {
    Button,
  },
  props: {
    imageURL: String,
    title: String,
    description: String,
    buttonText: String,
    link: String,
  },
};
</script>
<style lang="css" scoped>
.card-fade {
  background: #ffffff;
  display: flex;
  flex-direction: row;
  height: 320px;
}
.card-fade .content {
  padding: 35px 35px 50px;
  min-width: 290px;
  position: relative;
}
.card-fade .content::after {
  content: "";
  position: absolute;
  width: 30px;
  height: 100%;
  top: 0;
  left: 100%;
  background: linear-gradient(to right, #ffffff, rgba(255, 255, 255, 0));
}
.card-fade .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 35px;
  color: #33647e;
  margin-bottom: 5px;
}
.card-fade .content .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  color: #696f72;
  margin-bottom: 30px;
}
.card-fade .image {
  width: 100%;
  background-image: url(https://i.ibb.co/wNDGp7q/Card-Footer-Image.png);
  background-size: cover;
}
@media (max-width: 998px) {
  .card-fade .content .title {
    font-size: 24px;
    line-height: 29px;
  }
  .card-fade .content .description {
    font-size: 16px;
    line-height: 19px;
  }
}
@media (max-width: 768px) {
  .card-fade {
    flex-direction: column;
    height: 100%;
  }
  .card-fade .content::after {
    content: "";
    width: 100%;
    height: 30px;
    top: auto;
    left: 0;
    bottom: -30px;
    background: linear-gradient(to bottom, #ffffff, rgba(255, 255, 255, 0));
  }
  .card-fade .image {
    height: 120px;
  }
}
</style>
